export default "__VITE_ASSET__rtInWhLQ__"